import React from 'react';

import { Skeleton } from '@components/Skeleton';
import { Card } from '@components/Card';

import {
    cnPublication,
    publicationBlockCn,
    publicationDescriptionCn,
    publicationDescriptionFooterCn,
    publicationHeaderCn,
    publicationImgContainerCn,
    publicationImgSkeletonCn,
    publicationLikeSkeletonCn,
    publicationPriceCn,
    publicationPriceSkeletonCn,
    publicationTextSkeletonCn,
} from './Publication.const';
import type { IPublicationSkeletonProps } from './Publication.typings';

import './Publication.scss';

export const PublicationSkeleton: React.FC<IPublicationSkeletonProps> = props => (
    <Card
        contentClassName={props.className}
        className={cnPublication()}
    >
        <div className={publicationImgContainerCn}>
            <Skeleton className={publicationImgSkeletonCn} />
            <Skeleton className={publicationImgSkeletonCn} />
            <Skeleton className={publicationImgSkeletonCn} />
            <Skeleton className={publicationImgSkeletonCn} />
            <Skeleton className={publicationImgSkeletonCn} />
        </div>
        <div className={publicationHeaderCn}>
            <div className={publicationDescriptionCn}>
                <div>
                    <div className={publicationBlockCn}>
                        <Skeleton className={publicationTextSkeletonCn} />
                    </div>
                    <div className={publicationBlockCn}>
                        <Skeleton className={publicationTextSkeletonCn} />
                    </div>
                </div>
                <div className={publicationDescriptionFooterCn}>
                    <div className={publicationPriceCn}>
                        <Skeleton className={publicationPriceSkeletonCn} />
                    </div>
                    <Skeleton className={publicationLikeSkeletonCn} />
                </div>
            </div>
        </div>
    </Card>
);
